import React from "react";
import "./index.scss";
import { Button } from "antd";

type IProps = Readonly<{
  text: string;
  onHandleSubmit?: () => void;
  disabled?: boolean;
  htmlType?: "submit" | undefined;
}>;

export function SubmitButton(props: IProps) {
  const { onHandleSubmit, text, disabled, htmlType } = props;
  return (
    <Button
      className="Button-submit"
      onClick={onHandleSubmit}
      disabled={disabled}
      type="primary"
      htmlType={htmlType}
    >
      {text}
    </Button>
  );
}
